import React from "react";
import EditorShell from "../EditorShell";
import { TextField, TextareaField } from "../fields";
import ListArrayEditor from "../ListArrayEditor";
import { whereItFitsSchema, SECTION_DEFAULTS } from "../schemas";

const WhereItFitsEditor = ({ section, onSaved, onLiveChange }) => (
  <EditorShell
    sectionKey="where_it_fits"
    schema={whereItFitsSchema}
    defaults={SECTION_DEFAULTS.where_it_fits}
    section={section}
    onSaved={onSaved}
    onLiveChange={onLiveChange}
  >
    {(form) => (
      <>
        <TextField form={form} path="title" label="Section title" />
        <TextareaField
          form={form}
          path="description"
          label="Description"
          rows={2}
        />
        <ListArrayEditor
          form={form}
          name="cards"
          label="Cards"
          max={8}
          newItem={() => ({ title: "", subtitle: "", icon: "" })}
          emptyText='Add cards like "On your phone", "At home", "Zen Dens".'
          renderItem={({ index, form: f }) => (
            <>
              <TextField
                form={f}
                path={`cards.${index}.title`}
                label="Title"
                required
              />
              <TextField
                form={f}
                path={`cards.${index}.subtitle`}
                label="Subtitle"
              />
              <TextField
                form={f}
                path={`cards.${index}.icon`}
                label="Icon"
                hint="smartphone, home, sprout"
              />
            </>
          )}
        />
      </>
    )}
  </EditorShell>
);

export default WhereItFitsEditor;
